import React, {Component} from 'react';
import ListingContainer from "../../../containers/listing_container";
import {Button, Form, Grid, Header, Image, Label, Segment} from "semantic-ui-react";
import {CLERK_API_URL} from "../../../constants/api_routes";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import moment from "moment";
import Loader from "../../universal/loader";
import WeeklyAvailability from './weekly_availability';

class UpdateClerkUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            insuranceStartDate:undefined,
            insuranceEndDate:undefined,
            seniorClerkPay:this.props.selectedObject[0]["seniorclerkpay_pence"]/100,
            clerkEndDate:this.props.selectedObject[0]["end_date"]||undefined,
        }
    }


    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({isSaving:true});
        const formData = new FormData(event.target);
        if(this.state.clerkEndDate) {
            formData.append("end_date",this.state.clerkEndDate)
        }
        if(this.state.insuranceStartDate && this.state.insuranceEndDate){
            formData.append("insurance_start_date", this.state.insuranceStartDate);
            formData.append("insurance_end_date", this.state.insuranceEndDate);

        }
        this.props.updateDetails(CLERK_API_URL, formData, this.props.selectedObject[0].id, this.successCallback);
    };

    successCallback = (response) => {
        this.setState({isSaving:false});
        if (response.success || response['clerk_profile']) {
            this.props.onSuccess();
        }
    };

    render() {
        const currentEditingUser = this.props.selectedObject[0];
        return (
            <div>
                {this.state.isSaving && <Loader save={true}/>}
                <Header as='h2' textAlign='center'>
                    Update Clerk User
                </Header>
                <Form onSubmit={this.handleSubmit}>
                    <Grid stackable>
                        <Grid.Row>
                        <Grid.Column width={8}>
                            <Segment className='segment-width'>
                                <Label color='blue' ribbon>
                                    Profile Details
                                </Label>
                                <p></p>
                                <p style={{fontWeight: 600, fontSize: '1.3rem'}}>Email: <span
                                    style={{fontWeight: 200}}>{currentEditingUser.email}</span>
                                </p>
                                <Form.Group widths={2}>
                                <Form.Input label='Name' fluid icon='user' iconPosition='left' placeholder='Name'
                                            type='text' name="name" defaultValue={currentEditingUser.name}
                                            required/>
                                <Form.Input label='Mobile Number' fluid icon='mobile' iconPosition='left'
                                            placeholder='328659286'
                                            type='text' name="mobile_number"
                                            defaultValue={currentEditingUser['mobile_number']}
                                            />
                                </Form.Group>
                                <p className="format-bold">Emergency Contact Details:</p>
                                <Form.Group widths={2}>
                                <Form.Input label='Name / Relation' fluid icon='user' iconPosition='left'
                                            placeholder='Contact Name / Relation' defaultValue={currentEditingUser['emergencyname']}
                                            type='text' name="emergencyname"
                                />
                                <Form.Input label="Contact Number" icon='mobile' iconPosition='left'
                                            placeholder="123" defaultValue={currentEditingUser['emergencytelephone']}
                                            type='number'name="emergencytelephone"/>
                                </Form.Group>
                                <Form.Group widths={2} className='field'>
                                <Form.Input label="License Number" icon='at' iconPosition='left'
                                            placeholder='123' defaultValue={currentEditingUser['licenseno']}
                                            name="licenseno"/>
                                <Form.Input label="Date of Birth" icon='user' iconPosition='left'
                                            placeholder='8328659286' defaultValue={currentEditingUser['dob']}
                                            type='string' name="dob"
                                />
                                </Form.Group>
                                  <Form.Group widths={2}>
                                <Form.Input label='Name / Relation' fluid icon='user' iconPosition='left'
                                            placeholder='Contact Name / Relation' defaultValue={currentEditingUser['emergencyname']}
                                            type='text' name="emergencyname"
                                />
                                <Form.Input label="Contact Number" icon='mobile' iconPosition='left'
                                            placeholder="123" defaultValue={currentEditingUser['emergencytelephone']}
                                            type='number'name="emergencytelephone"/>
                                </Form.Group>
                                <Form.Group widths={2} className='field'>
                               <Form.Input
                                    label="Senior Clerk Pay"
                                    icon="gb pound"
                                    iconPosition="left"
                                    placeholder="0.00"
                                    name="seniorclerkpay_pence"
                                    value={this.state.seniorClerkPay}
                                    onChange={(e, { value }) => {
                                        // allow only numbers + decimal
                                        this.setState({seniorClerkPay:value});
                                    }}
                                    />
                                     <Form.Input style={{width:"200px",margin:"auto"}} label="End Date"
                                                                    type="date"
                                                                        value={this.state.clerkEndDate}
                                                                        onChange={(e, option) => {
                                                                            this.setState({clerkEndDate:option.value})
                                                                        }} />
                                </Form.Group>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Address Details
                                </Label>
                                <p></p>
                                <Form.Input label='Address Line 1' fluid
                                            placeholder='Street'
                                            type='street view'
                                            name="line1"
                                            defaultValue={currentEditingUser.line1}
                                            required/>
                                <Form.Input label='Address Line 2' fluid
                                            placeholder='Landmark'
                                            type='street view'
                                            name="line2"
                                            defaultValue={currentEditingUser.line2}
                                />
                                <Form.Group widths={2}>
                                    <Form.Input label='Locality' fluid
                                                placeholder='Region'
                                                type='text'
                                                name="locality"
                                                defaultValue={currentEditingUser.locality}
                                    />
                                    <Form.Input label='City' fluid
                                                placeholder='City'
                                                type='text'
                                                name="city"
                                                defaultValue={currentEditingUser.city}
                                    />
                                </Form.Group>
                                <Form.Group widths={2} className='field'>
                                    <Form.Input label='Country' fluid
                                                placeholder='Country'
                                                type='text'
                                                name="country"
                                                defaultValue={currentEditingUser.country}
                                    />
                                    <Form.Input label='Post Code' fluid
                                                placeholder='C2PN57'
                                                type='text'
                                                name="postcode"
                                                defaultValue={currentEditingUser.postcode}
                                                required
                                    />
                                </Form.Group>
                            </Segment>
                        </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <Segment style={{height: '100%'}}>
                                    <Label color='blue' ribbon>
                                        Provided Documents
                                    </Label>
                                    <Image.Group size="small">
                                        {currentEditingUser['insurance'] &&  currentEditingUser['insurance']['report']['url'] && <Image as='a' label="Insurance Document" target='_blank' src={currentEditingUser['insurance']['report']['url']} href={ currentEditingUser['insurance']['report']['url']} />}
                                        {currentEditingUser['sign'] && currentEditingUser['sign']['report']['url'] && <Image as='a' label="Signature" target='_blank' src={currentEditingUser['sign']['report']['url']} href={ currentEditingUser['sign']['report']['url']} />}
                                        {currentEditingUser['license'] && currentEditingUser['license']['report']['url'] && <Image as='a' label="License Document" target='_blank' src={currentEditingUser['license']['report']['url']} href={ currentEditingUser['license']['report']['url']} />}
                                    </Image.Group>
                                    {!currentEditingUser['insurance']['report']['url'] && !currentEditingUser['sign']['report']['url'] && !currentEditingUser['license']['report']['url'] && <p className="center-aligned pad-top">No Documents Provided</p>}
                                </Segment>

                            </Grid.Column>
                            {/* <Grid.Column width={8}>
                                <Segment style={{height: '100%'}}>
                                    <Label color='blue' ribbon>
                                        Documents
                                    </Label>
                                    <p></p>
                                    <Form.Group widths={2}>
                                        <Form.Field>
                                            <Form.Input label="Insurance" type='file' accept="image/*"
                                                        name="insurance"/>
                                        </Form.Field>
                                        <Form.Field><Form.Group widths={2}>
                                            <Form.Field>
                                                <label>Valid From:</label>
                                                <DayPickerInput placeholder="DD-MM-YYYY"
                                                                dayPickerProps={{
                                                                    todayButton: 'Today',
                                                                    firstDayOfWeek : 1,
                                                                }}
                                                                format="DD-MM-YYYY"
                                                                formatDate={formatDate}
                                                                parseDate={parseDate}
                                                                value={currentEditingUser['insurance_start_date']?moment(currentEditingUser['insurance_start_date'],"YYYY-MM-DD").format("DD-MM-YYYY"):undefined}
                                                                onDayChange={day => this.setState({insuranceStartDate: day})}/>
                                            </Form.Field>
                                            <Form.Field>
                                                <label>Valid Till:</label>
                                                <DayPickerInput placeholder="DD-MM-YYYY"
                                                                dayPickerProps={{
                                                                    todayButton: 'Today',
                                                                    firstDayOfWeek : 1,
                                                                }}
                                                                format="DD-MM-YYYY"
                                                                formatDate={formatDate}
                                                                parseDate={parseDate}
                                                                value={currentEditingUser['insurance_end_date']?moment(currentEditingUser['insurance_end_date'],"YYYY-MM-DD").format("DD-MM-YYYY"):undefined}
                                                                onDayChange={day => this.setState({insuranceEndDate: day})}/>
                                            </Form.Field>
                                        </Form.Group>
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Field>
                                    </Form.Field>
                                    <Form.Input label='License Document' type='file' accept="image/*" name="license"/>
                                    <Form.Input label='Signature' type='file' accept="image/*" name="sign"/>
                                </Segment>
                            </Grid.Column> */}
                        </Grid.Row>
                        <div className="submit-buttons">
                            <Button primary fluid disabled={this.state.disableSave}>Update User</Button>
                        </div>
                    </Grid>
                </Form>
                <WeeklyAvailability clerkData={currentEditingUser} callbackFn={() => { this.props.onSuccess();this.props.getList(CLERK_API_URL) }}></WeeklyAvailability>
            </div>
        );
    }
}

export default ListingContainer(UpdateClerkUser);


// WEBPACK FOOTER //
// ./src/views/user/clerk/update_user.js